import React from "react";

/**
 * The head/tail marks exactly as the live canvas draws them.
 *
 * The canvas carries no 頭/尾 text any more — shape IS the encoding there, so
 * an operator can only read it if the same shapes appear where the roles are
 * configured. Keeping one component for both places means the settings page
 * can never drift from what is actually painted on the canvas.
 *
 * Shapes (not colours) do the work, so this survives a colour-blind operator
 * and a sunlit screen. A machine has at most these two tags — no third
 * "point" role exists any more.
 */
const RoleShape = ({ role, color = "#722ed1", size = 10 }) => {
  if (role === "head") {
    // Triangle, drawn pointing right so it reads as "the leading end" in a
    // static list. On the canvas the same triangle is rotated to the heading.
    return (
      <span
        aria-hidden="true"
        style={{
          display: "inline-block",
          width: 0,
          height: 0,
          borderTop: `${size / 2}px solid transparent`,
          borderBottom: `${size / 2}px solid transparent`,
          borderLeft: `${size}px solid ${color}`,
          verticalAlign: "middle",
        }}
      />
    );
  }

  // tail
  return (
    <span
      aria-hidden="true"
      style={{
        display: "inline-block",
        width: size,
        height: size,
        borderRadius: 1,
        backgroundColor: color,
        verticalAlign: "middle",
      }}
    />
  );
};

export default RoleShape;
